<mat-label class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">{{componentDefinition?.label}}</mat-label>

<div class="ft-password-entry">

  <mat-form-field *ngIf="requireOriginalPassword">
    <mat-label class="control-label">Existing password</mat-label>
    <input matInput
           id="existing-pass" name="e-pass"
           [type]="hideOriginalPassword ? 'password' : 'text'"
           [formControl]="formControlExistingPassword"
           [errorStateMatcher]="matcherExistingPassword"
           (blur)="validateExistingPassword($event.target.value)"
           required/>
    <mat-icon matSuffix (click)="onHideOriginalPassword()" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideOriginalPassword">
        <mat-icon>{{hideOriginalPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
    </mat-icon>
  </mat-form-field>

  <mat-form-field>
    <mat-label class="control-label">New password</mat-label>
    <input matInput
           id="new-pass" name="n-pass"
           [type]="hidePassword ? 'password' : 'text'"
           [formControl]="formControlNewPassword"
           [errorStateMatcher]="matcherNewPassword"
           [scPasswordValidator]="validatorMsg"
           (blur)="validateNewPassword($event.target.value)"
           required (change)="newPasswordOnChange()" autocomplete="off">
    <mat-icon matSuffix (click)="onHidePassword()" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
        <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
    </mat-icon>
  </mat-form-field>

  <mat-form-field>
    <mat-label class="control-label">Confirm password</mat-label>
    <input matInput
           id="confirm-pass" name="c-pass"
           [type]="hideConfirmPassword ? 'password' : 'text'"
           [formControl]="formControlConfirmPassword"
           [errorStateMatcher]="matcherConfirmPassword"
           (blur)="validateConfirmPassword($event.target.value)"
           required>
    <mat-icon matSuffix (click)="onHideConfirmPassword()" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword">
      <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
    </mat-icon>
  </mat-form-field>

  <span *ngIf="validatorMsg.passwordValidationErrMsg != null" role="alert" class="validation">
    <div class="has-error alert alert-warning" [innerHtml]="validatorMsg.passwordValidationErrMsg">
    </div>
  </span>

</div>

